/**
 * Restrict navigation / resource URLs to safe schemes.
 * Allows: http(s), mailto, relative paths, hash fragments.
 * Rejects: javascript:, data:, vbscript:, and unknown schemes.
 */

const ALLOWED_ABSOLUTE = /^(https?:|mailto:)/i;
const RELATIVE_OR_HASH = /^(\/|\.\/|\.\.\/|#|[a-zA-Z0-9_@%+-][^:]*$)/;

export function isSafeUrl(raw: unknown): boolean {
  if (typeof raw !== 'string') return false;
  const url = raw.trim();
  if (!url) return false;

  const lower = url.toLowerCase();
  if (
    lower.startsWith('javascript:') ||
    lower.startsWith('data:') ||
    lower.startsWith('vbscript:')
  ) {
    return false;
  }

  // Absolute with scheme
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) {
    return ALLOWED_ABSOLUTE.test(url);
  }

  return RELATIVE_OR_HASH.test(url);
}

/** Returns the URL if safe, otherwise fallback (default '#'). */
export function sanitizeUrl(raw: unknown, fallback = '#'): string {
  if (typeof raw !== 'string') return fallback;
  const url = raw.trim();
  if (!url) return fallback;
  return isSafeUrl(url) ? url : fallback;
}
